import { render, staticRenderFns } from "./import-bonus.vue?vue&type=template&id=16f32520&scoped=true&"
import script from "./import-bonus.vue?vue&type=script&lang=js&"
export * from "./import-bonus.vue?vue&type=script&lang=js&"
import style0 from "./import-bonus.vue?vue&type=style&index=0&id=16f32520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f32520",
  null
  
)

export default component.exports